import PropTypes from 'prop-types'
import React from 'react'

import Baseball from '../images/activities/Baseball.svg'
import Basketball from '../images/activities/Basketball.svg'
import CrossCountry from '../images/activities/Cross_country.svg'
import Football from '../images/activities/Football.svg'
import Gymnastics from '../images/activities/Gymnastics.svg'
import Hockey from '../images/activities/Hockey.svg'
import Lacrosse from '../images/activities/Lacrosse.svg'
import Reset from '../images/activities/Reset.svg'
import Soccer from '../images/activities/Soccer.svg'
import Softball from '../images/activities/Softball.svg'
import Swimming from '../images/activities/Swim.svg'
import Tennis from '../images/activities/Tennis.svg'
import Track from '../images/activities/Track.svg'
import Volleyball from '../images/activities/Volleyball.svg'
import Wrestling from '../images/activities/Wrestling.svg'

const activityIcons = {
  Baseball,
  Basketball,
  'Cross Country': CrossCountry,
  Football,
  Gymnastics,
  Hockey,
  Lacrosse,
  Soccer,
  Softball,
  Swimming,
  Tennis,
  'Track & Field': Track,
  Volleyball,
  Wrestling,
  M: Reset
}

const ActivityIcon = ({activity}) => (
  <img src={activityIcons[activity.Name] || activityIcons[activity.Tag]} />
)

ActivityIcon.propTypes = {
  activity: PropTypes.object.isRequired
}

export default ActivityIcon
